<template>
    <div class="main_section">
		<div class="title mb-5">
			<h2>{{ $t('client_account') }}</h2>
			<div v-if="!user.hotel.checked_out">
				<h4 class="mt-2">{{user.hotel.hotel_name}}</h4>
				<p class="mt-3">{{$t('client_account_sentence')}}</p>
		   	</div>
		   	<div v-else class="mt-5">
				<vx-card>
					<p align="center">{{ $t('checkout_done') }}</p>
				</vx-card>
			</div>
		</div>
        <account-items v-if="load_account && !user.hotel.checked_out" v-bind:page="'account'" v-bind:checkout_done="false" v-bind:rsvID="user.hotel.num_reserva" v-bind:user="user"></account-items>
	</div>
</template>

<script>

import AccountItems from '@/views/components/AccountItems.vue';

// import themeConfig from '@/../themeConfig.js';

export default {
	name: 'eCommerceAccount',
	components: {
		AccountItems
	},
    data(){
		return {
			user: JSON.parse(localStorage.getItem('userSession')),
			load_account: false
		}
	},
	methods: {
		/*set_account: function(account) {
			this.account = account;
		},*/
	},
	watch: {
		/*item_rejected: function(new_val, old_val) {
			this.popupActive = this.item_rejected !== null;
		},*/
		/*popupActive: function(new_val, old_val) {
			if(!new_val)
				this.item_rejected = null;
		}*/
	},
	computed: {

	},
	created: function() {
		if(Object.keys(this.user.hotel).length === 0) {
			this.$router.push({name: 'home'});
			return;
		}
		let that = this;
		this.checkRsvStatus(function(data) {
			if([4, 5].indexOf(data) === -1) {
				that.checkout_done = true;
				that.user.hotel.checked_out = true;
				localStorage.setItem('userSession', JSON.stringify(that.user));
			}
			else {
				that.load_account = true;
			}
		});
	}
}
</script>

<style scoped>
    
</style>